export const version = '0.1.0-next.0'